/** Safely extract a user-facing string from axios/API errors (avoids "[object Object]" toasts). */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const responseData = (error as { response?: { data?: unknown } })?.response?.data;

  if (typeof responseData === 'string' && responseData.trim()) {
    return responseData.trim();
  }

  if (responseData && typeof responseData === 'object') {
    const record = responseData as Record<string, unknown>;
    const candidate = record.message ?? record.error;
    const errorSource = typeof record.errorSource === 'string' ? record.errorSource : null;
    const interaktErrors = Array.isArray(record.interaktErrors) ? record.interaktErrors : null;

    let message = '';
    if (typeof candidate === 'string' && candidate.trim()) {
      message = candidate.trim();
    } else if (Array.isArray(candidate)) {
      const parts = candidate.map(String).filter(Boolean);
      if (parts.length) message = parts.join(', ');
    } else if (candidate && typeof candidate === 'object') {
      const parts = Object.values(candidate as Record<string, unknown>)
        .flatMap((value) => (Array.isArray(value) ? value : [value]))
        .map(String)
        .filter(Boolean);
      if (parts.length) message = parts.join(', ');
    } else if (typeof record.error === 'string' && record.error.trim()) {
      message = record.error.trim();
    }

    if (message) {
      if (errorSource === 'interakt') {
        const extra =
          interaktErrors && interaktErrors.length
            ? ` (${interaktErrors
                .map((e) => (typeof e === 'string' ? e : JSON.stringify(e)))
                .join('; ')})`
            : '';
        const base = message.startsWith('Interakt') ? message : `Interakt: ${message}`;
        return `${base}${extra}`;
      }
      if (errorSource === 'database') {
        return message.startsWith('Database') ? message : `Database: ${message}`;
      }
      if (errorSource === 'validation') {
        return message;
      }
      return message;
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message.trim();
  }

  return fallback;
};
